import { navItems } from '@/mocks/siteContent';

export default function SiteFooter() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 border-b border-background-200 pb-10 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded bg-primary-600 text-background-50">
                <i className="ri-quill-pen-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">五一爆料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              面向五一期间网传消息的求证栏目：以辟谣与实锤归档真实与否，用聊天记录截图流出还原传播路径，
              请爆料人现身说明信源背景——只讲依据，不带节奏。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="mb-4 font-label text-xs font-semibold tracking-[0.2em] text-foreground-500">
              栏目导航
            </h3>
            <ul className="space-y-2.5">
              {navItems.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    className="text-sm text-foreground-800 transition-colors hover:text-primary-600"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="mb-4 font-label text-xs font-semibold tracking-[0.2em] text-foreground-500">
              联系方式
            </h3>
            <ul className="space-y-2.5 text-sm text-foreground-800">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" aria-hidden="true" />
                verify@readdy.demo（示意）
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600" aria-hidden="true" />
                台账工作日持续更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-600" aria-hidden="true" />
                内容均为公开信息求证梳理
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-3 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © 2026 五一爆料 · 本页为网传消息求证演示，不构成对任何个人或组织的法律定性。
          </p>
          <p className="text-xs text-foreground-500">遇不实信息，建议同时通过权威渠道核验。</p>
        </div>
      </div>
    </footer>
  );
}